<template>
  <div>
    <h1 class="settings-title">
      Api Keys
    </h1>
    <div class="settings-form">
      <b-form-group>
        <label class="settings-label">
          Public Key
        </label>
        <CopyInput :value="appKey.public_key"/>
      </b-form-group>
      <b-form-group>
        <label class="settings-label">
          Secret Key
        </label>
        <CopyInput
          :value="appKey.private_key"
          :hidden="true"/>
      </b-form-group>
      <b-button
        :disabled="!appKeyLoaded"
        class="btn-round btn-save"
        @click="openAppKeyRegenerateModal">
        Regenerate Keys
      </b-button>
    </div>
    <AppKeyRegenerateModal
      ref="appKeyRegenerateModal"
      @updated="fetchAppKey($route.params.merchant_id)"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppKeyRegenerateModal from './modals/AppKeyRegenerateModal';

import CopyInput from '../../../common/CopyInput';

export default {
  name: 'ApiKeySettings',
  components: {
    CopyInput,
    AppKeyRegenerateModal,
  },
  computed: {
    ...mapGetters({
      appKeyLoaded: 'merchant/appKeyLoaded',
      appKey: 'merchant/appKey',
    }),
  },
  mounted() {
    this.fetchAppKey(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchAppKey: 'merchant/fetchAppKey',
    }),
    openAppKeyRegenerateModal() {
      this.$refs.appKeyRegenerateModal.show();
    },
  },
};
</script>
